import { ServiceWaitingPeriodType } from "@platform/openapi-types";

/** Human-readable labels for service waiting period types */
export const SERVICE_TYPE_LABELS: Record<ServiceWaitingPeriodType, string> = {
  preventive: "Preventive",
  basic: "Basic",
  major: "Major",
  ortho: "Ortho",
  sealants: "Sealants",
  spaceMaintainers: "Space Maintainers",
  generalAnesthesia: "General Anesthesia",
  compositeWhiteFillings: "Composite (White) Fillings",
  endodontics: "Endodontics",
  periodonticsSurgical: "Periodontics (Surgical)",
  periodonticsNonSurgical: "Periodontics (Non-Surgical)",
  oralSurgerySimple: "Oral Surgery (Simple)",
  oralSurgeryComplex: "Oral Surgery (Complex)",
  implants: "Implants",
};
